/**
 * Sensitive field names shared across Creator's URL and telemetry boundaries.
 *
 * Keep exact external contract names here. Boundary-specific protections may
 * add broader patterns, but should reuse these values instead of duplicating
 * capability-token or personally identifiable field names.
 */
const SENSITIVE_FIELD_NAMES = {
	accessCode: 'access_code',
	email: 'email',
	readToken: 'read_token',
	userToken: 'user_token',
} as const;

export default SENSITIVE_FIELD_NAMES;
